import { TourListWrapper, BtnControl } from "./styled"
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import TourItem from "components/TourItem"

const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    // variableWidth: true,
    slidesToScroll: 4,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,

};
function SampleNextArrow(props) {
    const { className, onClick } = props;
    return (
        <BtnControl className={`${className}`} onClick={onClick}><FaAngleRight /></BtnControl>
    );
}

function SamplePrevArrow(props) {
    const { className, onClick } = props;
    return (
        <BtnControl className={`${className}`} onClick={onClick}>
            <FaAngleLeft />
        </BtnControl>
    );
}


const TourList = ({ data, title }) => {
    return (
        <TourListWrapper>
            <div className="tour_list_name">
                <h1 className="s-30 text-black">{title}</h1>
            </div>
            <Slider {...settings}>
                {
                    data.map((item, key) => (
                        <TourItem
                            key={key}
                            thumbnail={item.thumbnail}
                            tourName={item.name}
                            tourPrice={item.final_price}
                            discount={item.discount}
                            tourOldPrice={item.price}
                            slug={item.slug}
                        />
                    ))
                }
            </Slider>

        </TourListWrapper>
    )
}

export default TourList